/**
 * Language-driven month names (QL-108) — the one table the web (charts, flow
 * widgets, savings plans) and the PDF blocks read. Month NAMES follow the UI
 * language (translation, not regional settings), and are produced from these
 * fixed tables — never from Intl.DateTimeFormat/toLocale*, so rendering is
 * deterministic across ICU versions.
 */

import { pickT } from "../i18n";
import type { TranslationTable } from "../types/translation-table";

type MonthNames = { short: readonly string[]; long: readonly string[] };

const MONTH_NAMES: TranslationTable<MonthNames> = {
  en_GB: {
    short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    long: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  nb_NO: {
    short: [
      "jan.",
      "feb.",
      "mars",
      "apr.",
      "mai",
      "juni",
      "juli",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "des.",
    ],
    long: [
      "januar",
      "februar",
      "mars",
      "april",
      "mai",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "desember",
    ],
  },
};

/** Month name for a 0-based month index in the given UI language. */
export function getMonthName(
  monthIndex: number,
  language: string,
  style: "short" | "long" = "short",
): string {
  return pickT(MONTH_NAMES, language)[style][((monthIndex % 12) + 12) % 12] ?? "";
}
